module.exports = __webpack_public_path__ + "static/bigant-portrait.49ef401d.png";


//////////////////
// WEBPACK FOOTER
// ./src/gallery/bigant-portrait.png
// module id = 536
// module chunks = 27362984104999